<mf-page title="Editar plantilla genérica">
  @if (templateGenericDto) {
    <mf-template
      [templateDto]="templateGenericDto"
      (save)="save($event)"
      (closeButtonClick)="close()" />
  }
</mf-page>
